module.exports = __webpack_public_path__ + "static/media/spell-check.067b3f67.svg";